import { decrypted } from "@/plugins/crypto";
import usersRequests from "@/services/admin/users-service";

export function getLoginUserId() {
  let userId = "";

  let user = localStorage.getItem("user");

  if (user) {
    let decryptedUser = decrypted(user);
    userId = String(decryptedUser.user_id ?? "");
  }
  return userId;
}

export function getUserData() {
  let user = localStorage.getItem("user");
  let decryptedUser = decrypted(user);

  return {
    dni: decryptedUser.dni,
    name: decryptedUser.name,
    email: decryptedUser.email,
  };
}

/**
 * Get complete user profile data from backend
 * Returns full user object with image_url, roles, etc.
 */
export async function getCompleteUserData() {
  try {
    const userId = getLoginUserId();
    const response = await usersRequests.getOne(userId);
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error("Error fetching complete user data:", error);
    return null;
  }
}
